import { render, staticRenderFns } from "./HighTechList.vue?vue&type=template&id=849bb668&scoped=true"
import script from "./HighTechList.vue?vue&type=script&lang=js"
export * from "./HighTechList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849bb668",
  null
  
)

export default component.exports